// @ts-check

export const HEADER_HEIGHT = 57;
export const CHECKBOX_WIDTH = 56;
